import { ButtonHTMLAttributes } from 'react';
import { MainButton, SecondaryButton } from './styleGuide';
import { useAppSelector } from '../../hooks/hooksRedux';
import { RootState } from '../../store';
import { defaultButton, defaultColors, defaultBackground } from '../../styles/style-guide';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  text: string;
  loading?: boolean;
  disabled?: boolean;
  className?: string;
}

const Loading = () => (
  <svg className="h-5 w-5 animate-spin text-black" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
  </svg>
);

function MainCustomButton({ text, loading, disabled, className, ...rest }: Props) {
  const { button, colors } = useAppSelector((state: RootState) => state.styleGuide.data);

  const primaryButtonColor = button.primary || defaultButton.primary;
  const secondaryColor = colors.white || defaultColors.white;

  return (
    <MainButton
      $colorText={secondaryColor}
      $backgroundColor={primaryButtonColor}
      {...rest}
      disabled={loading || disabled}
      className={className}
    >
      {loading ? <Loading /> : text}
    </MainButton>
  );
}

function SecondaryCustomButton({ text, ...rest }: Props) {
  const { colors, button } = useAppSelector((state: RootState) => state.styleGuide.data);

  const primaryButtonColor = button.primary || defaultButton.primary;
  const primaryColor = colors.primary || defaultColors.primary;

  return (
    <SecondaryButton $color={primaryColor} $backgroundColor={primaryButtonColor} {...rest}>
      {rest.loading ? <Loading /> : text}
    </SecondaryButton>
  );
}

export { MainCustomButton, SecondaryCustomButton };
